import { render } from "./Auth.page.vue?vue&type=template&id=69809678&ts=true"
import script from "./Auth.page.vue?vue&type=script&lang=ts"
export * from "./Auth.page.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__